import React from "react";
import {
  Box,
  Modal,
  Typography,
  IconButton,
  Button,
  Tooltip,
} from "@mui/material";
import { Close } from "@mui/icons-material";
const { formatInTimeZone } = require("date-fns-tz");

const checkInView = ({ checkIn, timezone, handleCheckIn }) => {
  if (checkIn) {
    const { createdAt } = checkIn;
    const datePattern = "M/d/yyyy h:mm a z";
    const dateText = formatInTimeZone(
      createdAt.toDate(),
      timezone,
      datePattern,
    );
    return (
      <Box display={"flex"} alignItems={"center"}>
        <Typography sx={{ flex: 1 }}>{dateText}</Typography>
        <Button
          onClick={() => {
            handleCheckIn(false);
          }}
        >
          Clear
        </Button>
      </Box>
    );
  } else {
    return (
      <Box display={"flex"} alignItems={"center"}>
        <Typography sx={{ flex: 1 }}>Not checked in</Typography>
        <Button
          onClick={() => {
            handleCheckIn(true);
          }}
        >
          Check In
        </Button>
      </Box>
    );
  }
};

const CheckInsInfoModal = ({
  open,
  event,
  ticketId,
  handleClose,
  handleCheckIn,
}) => {
  const { tickets, sessions, timezone } = event || {};
  const ticket = (tickets || []).find(({ id }) => id === ticketId);
  const { checkIn, sessionCheckIns } = ticket || {};

  if (!ticket) {
    return;
  }

  return (
    <Modal open={open}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "100%", sm: "100%", md: 600 },
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
          maxHeight: "90vh",
          overflow: "auto",
        }}
      >
        <Box display={"flex"}>
          <Typography flexGrow={"1"} variant="h6">
            Check In Status
          </Typography>
          <Tooltip title="Close">
            <IconButton
              onClick={() => {
                handleClose();
              }}
            >
              <Close />
            </IconButton>
          </Tooltip>
        </Box>
        <Box marginTop={"20px"}>
          <Typography color={"primary.lightText"}>Event Check In:</Typography>
          {checkInView({
            checkIn,
            timezone,
            handleCheckIn: (checkedIn) => {
              handleCheckIn(checkedIn);
            },
          })}
          {(sessions || []).map((session) => {
            const { id: sessionId, name: sessionName } = session;
            const sessionCheckIn = (sessionCheckIns || {})[sessionId];
            return (
              <Box marginTop={"10px"} key={`session-check-in-${sessionId}`}>
                <Typography color={"primary.lightText"}>
                  {`${sessionName}:`}
                </Typography>
                {checkInView({
                  checkIn: sessionCheckIn,
                  timezone,
                  handleCheckIn: (checkedIn) => {
                    handleCheckIn(checkedIn, sessionId);
                  },
                })}
              </Box>
            );
          })}
        </Box>
      </Box>
    </Modal>
  );
};

export default CheckInsInfoModal;
